<template lang="html">
    <div class="content">
        <template>
            <!-- open a modal with a loader the time of the pdf is generated -->
            <div class="loader">
                <img src="../../../assets/img/grid_loader.svg" />
                <p>Génération du PDF en cours</p>
            </div>

        </template>
    </div>
</template>

<script>
    import moment from 'moment'
    moment.locale('fr')
    export default {
        data() {
            return {
                title:          'Création d\'une fiche produit',
                icon:           'sync',
                moment,
            }
        },

        methods: {
            onClose() {
                this.$eventHub.$emit('close-modal')
            },

            onValidate() {
                this.onClose()
            }
        },
        mounted(){
            this.$eventHub.$emit('hide-modal-actions')

            let downloadLink = document.createElement('A');
            this.axios.get(`/api/generate-pdf/${this.$route.params.id}`, {
                responseType: 'blob'
            })
            .then(response => {
                this.onClose()
                const data = window.URL.createObjectURL(response.data)

                downloadLink.href = data
                downloadLink.download = this.$store.state.single.data.code+"-V"+this.$store.state.single.data.version+".zip";
                document.body.appendChild(downloadLink)
                downloadLink.click()
                document.body.removeChild(downloadLink)
                this.axios.post('/api/delete-zip')
            })
        }

    }
</script>

<style lang="stylus" scoped>
    div.content
        padding 1rem 4rem

    .loader
        display flex
        flex-direction column
        align-items center
        width 100%
        padding 3rem 0

        img
            margin 0 0 3rem

</style>



// WEBPACK FOOTER //
// src/views/products/single/LoadPDF.vue